import { useSite } from '../../context/SiteProvider.jsx';
import { formatDateTime } from '../../lib/format.js';

const STATUS_KEYS = {
  pending: 'statusPending',
  confirmed: 'statusConfirmed',
  shipped: 'statusShipped',
  delivered: 'statusDelivered',
  cancelled: 'statusCancelled',
};

export function StatusBadge({ status }) {
  const { t } = useSite();
  return <b className={`status-badge status-${status}`}>{t(STATUS_KEYS[status] ?? status)}</b>;
}

export function OrderSummaryCard({ order }) {
  const { t, pick, money } = useSite();

  return (
    <div className="order-summary-card">
      <h3>{t('orderSummary')}</h3>

      <div className="order-lines">
        {order.items.map((item, index) => (
          <article key={index} className="cart-item">
            {item.imageUrl ? (
              <div className="cart-item-thumb">
                <img src={item.imageUrl} alt="" />
              </div>
            ) : null}
            <div>
              <h4>{pick(item.name)}</h4>
              <p>
                {pick(item.sizeLabel)} · {money(item.unitPrice)} × {item.quantity}
              </p>
            </div>
            <strong>{money(item.lineTotal)}</strong>
          </article>
        ))}
      </div>

      <div className="order-totals">
        <div>
          <span>{t('subtotal')}</span>
          <b>{money(order.subtotal)}</b>
        </div>
        <div>
          <span>{t('deliveryFee')}</span>
          <b>{order.deliveryFee > 0 ? money(order.deliveryFee) : t('freeDelivery')}</b>
        </div>
        <div className="order-total-row">
          <span>{t('orderTotal')}</span>
          <b>{money(order.total)}</b>
        </div>
      </div>

      <div className="order-delivery">
        <span>{t('deliveryDetails')}</span>
        <p>
          {order.customerName} · {pick(order.governorate)}
        </p>
      </div>
    </div>
  );
}

export function OrderTimeline({ timeline }) {
  const { t, language } = useSite();

  return (
    <div className="order-timeline">
      <h3>{t('trackTimeline')}</h3>
      <ol>
        {timeline.map((event, index) => (
          <li key={index} className={index === timeline.length - 1 ? 'is-current' : ''}>
            <StatusBadge status={event.status} />
            <span>{formatDateTime(event.createdAt, language)}</span>
            {event.note ? <p>{event.note}</p> : null}
          </li>
        ))}
      </ol>
    </div>
  );
}
